import { createSlice } from "@reduxjs/toolkit";

// Define a type for the slice state
interface IUtilityState {
  previousPage: any;
}

// Define the initial state using that type
const utilityInitialState: IUtilityState = {
  previousPage: null,
};

export const utilitySlice = createSlice({
  name: "utility",
  initialState: utilityInitialState,
  reducers: {
    setPreviousPage: (state, action) => {
      state.previousPage = action.payload.previousPage;
  },
  },
});

export const utilityActions = utilitySlice.actions;

export default utilitySlice.reducer;
